import { render, staticRenderFns } from "./RevenueDetails.vue?vue&type=template&id=40543cc1"
import script from "./RevenueDetails.vue?vue&type=script&lang=js"
export * from "./RevenueDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports